
import Box, { BoxProps } from "@mui/material/Box";
import Link from "@mui/material/Link";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { preventDefaultBehaviour } from "designSystem/utilities/prevent-default-behavior";
import { Button, Menu } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { getLocationForUrl } from "csi/utility/routerUtility";
import { C8Node } from "csi/typings";
import UserMenuItem from "csi/user/UserMenuItem";
import React, { FunctionComponent } from "react";

interface UserGroupButtonProps extends BoxProps {
	displayAsLink?: boolean;
	owner?: C8Node;
	users: C8Node[];
	onMenuItemClick?: (event: React.MouseEvent<HTMLElement>, user: C8Node) => void;
}

const UserGroupButton: FunctionComponent<UserGroupButtonProps> = (props) => {
	const loc = useLocale();
	const {
		users,
		owner,
		displayAsLink,
		onMenuItemClick,
		...otherProps
	} = props;

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	/** open the popup */
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		preventDefaultBehaviour(event);
		setAnchorEl(event.currentTarget);
	};

	/** Close the popup */
	const handleClose = (event: React.MouseEvent<HTMLElement>) => {
		preventDefaultBehaviour(event);
		setAnchorEl(null);
	};

	/** null check on the user array can be removed after reply feature is completed */
	return (
		<Box {...otherProps}>
			<Box display="flex">
				<Button
					design="defaultOnGrey"
					onClick={handleClick}
					startIcon={<SupervisorAccountIcon />}
				>
					{users.length}
				</Button>
			</Box>
			<Menu
				anchorEl={anchorEl}
				keepMounted
				onClose={handleClose}
				open={Boolean(anchorEl)}
			>
				{users.filter(Boolean)
					.map((user) =>
						displayAsLink ? (
							<Link href={getLocationForUrl(user.$URL)} key={user.$URL}>
								<UserMenuItem
									description={owner?.$URL == user.$URL ? `(${loc.resource("Owner")})` : null}
									user={user}
								/>
							</Link>
						)
							: (
								<UserMenuItem
									description={owner && owner.$URL == user.$URL ? `(${loc.resource("Owner")})` : null}
									key={user.$URL}
									onClick={(event) => onMenuItemClick ? onMenuItemClick(event, user) : preventDefaultBehaviour(event)}
									user={user}
								/>
							),
					)}
			</Menu>
		</Box>
	);
};

export default UserGroupButton;
